<template>
	<div class="visits">
		<v-layout row wrap fill-height>
			<v-flex xs12 class="menu-column hidden-xs-and-down">
				<Header />
			</v-flex>

			<v-flex xs12 class="div-container-visits-main">

				<div class="div-container-visits-content">
					<v-layout row wrap>
						<v-flex xs12 sm12 md12>
							<div class="div-container-selects">
								<div class="div-container-filters">
									<date-range-picker :startDate="startDate" :endDate="endDate" presets="Mmty"
										@select="date_range_select"></date-range-picker>
									<select-plus label="Anunciantes" noDataText="Nenhum anunciante"
										itemName="anunciante" :selected="rootSelectedAdvertisers"
										:items="advertiserList" v-model="selectedAdvertisers" itemText="reg_name"
										returnObject />
								</div>
								<div class="div-container-filters-button">
									<button :disabled="!!dataLoading" v-on:click="load_visits"
										class="button-generate-note">
										<v-icon class="material-icons-outlined" size="40">bolt</v-icon>
										<p>Gerar relatório</p>
									</button>
								</div>
							</div>
						</v-flex>
					</v-layout>

					<v-layout row wrap>
						<v-flex xs12 sm12 md12>
							<div class="div-container-card-quant-visits">
								<p class="paragrafo-title">Tráfego gerado</p>
								<p class="paragrafo-subtitle">Quantidade de visitas</p>
								<p class="paragrafo-value">{{ add_thousands_sep(totalVisits) }}</p>
							</div>
						</v-flex>
					</v-layout>
				</div>

				<div class="div-container-dataTable-visits">
					<v-data-table :headers="visitsHeaders" :items="visitsItems" class="elevation-10"
						rows-per-page-text="Itens por página" :rows-per-page-items="[10, 100, 500]"
						no-data-text="Sem visitas a exibir" :loading="dataLoading" :total-items="totalVisits"
						:pagination.sync="pagination">
						<v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
						<template slot="items" slot-scope="props">
							<td class="font-weight-black">{{ props.item.dtstring }}</td>
							<td class="text-xs-left">{{ props.item.advertiser_name }}</td>
							<td class="font-weight-black text-xs-left">
								{{ props.item.campaign_name }}
							</td>
							<td class="text-xs-left">{{ props.item.ref_uri }}</td>
							<td class="text-xs-left" v-if="includeMgfKeys">
								{{ props.item.mgf_keys }}
							</td>
						</template>
					</v-data-table>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import Header from '../components/Header.vue'
import DateRangePicker from 'magafilio-vue/components/DateRangePicker'
import SelectPlus from 'magafilio-vue/components/SelectPlus'
import { affiliate_api } from '@/api'
import dayjs from 'dayjs'


export default {
	name: 'Visits',
	mixins: [affiliate_api],
	components: {
		Header,
		DateRangePicker,
		SelectPlus,
	},
	data() {
		return {
			totalVisits: 0,
			dataLoading: false,
			canRefresh: false,
			includeMgfKeys: false,
			selectedAdvertisers: [],
			visitsItems: [],
			startDate: dayjs().startOf('day'),
			endDate: dayjs().endOf('day'),
			pagination: {
				sortBy: 'datetime',
				descending: true,
			},
		}
	},
	computed: {
		visitsHeaders: function () {
			if (this.includeMgfKeys) {
				return [
					{
						text: 'Data/hora',
						align: 'left',
						value: 'datetime',
						width: '10%',
					},
					{
						text: 'Anunciante',
						value: 'advertiser.register.reg_name',
						width: '25%',
					},
					{ text: 'Campanha', value: 'campaign', width: '15%' },
					{ text: 'URI', value: 'ref_uri', width: '40%' },
					{ text: 'Chaves MGF', value: 'mgf_keys', width: '15%' },
				]
			} else {
				return [
					{
						text: 'Data/hora',
						align: 'left',
						value: 'datetime',
						width: '20%',
					},
					{ text: 'Anunciante', value: 'advertiser', width: '20%' },
					{ text: 'Campanha', value: 'campaign', width: '25%' },
					{ text: 'URI', value: 'ref_uri', width: '35%' },
				]
			}
		},
		affiliate: function () {
			return (this.$root.affiliate && Object.keys(this.$root.affiliate).length > 0)
				? this.$root.affiliate
				: {}
		},
		rootSelectedAdvertisers: function () {
			return (
				(this.$root.selectedAdvertisers &&
					Object.values(this.$root.selectedAdvertisers)) ||
				[]
			)
		},
		advertiserList: function () {
			let advertiserList = this.$root.advertiserList
			if (!Array.isArray(advertiserList) || !advertiserList.length) return []
			return advertiserList
		},
	},
	methods: {
		add_thousands_sep(x) {
			var parts = x.toString().split(',')
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			return parts.join(',')
		},
		date_range_select: function (range) {
			if (this.startDate != range.startDate || this.endDate != range.endDate) {
				this.startDate = range.startDate
				this.endDate = range.endDate
			}
		},
		fetch_visits: async function (aff_id, query) {
			let visits = await this.get_transactions(aff_id, query)
			visits.data.entries = visits.data.entries.map((visit) => {
				visit.dtstring = new Date(visit.datetime).toLocaleString()
				visit.campaign_name = visit.campaign.reg_name
				visit.advertiser_name = visit.advertiser.register.reg_name

				if (typeof visit.mgf_keys !== 'undefined') {
					this.includeMgfKeys = true
				}
				return visit
			})
			return visits
		},
		load_visits: async function () {
			this.canRefresh = true

			if (!this.affiliate._id) {
				return
			}

			try {
				this.dataLoading = true

				let query = {
					start: this.pagination.page,
					limit: this.pagination.rowsPerPage,
					type: 'view',
					start_date: this.startDate.toISOString(),
					end_date: this.endDate.toISOString(),
					sort_by: this.pagination.sortBy,
					sort_dir: this.pagination.descending ? 'desc' : 'asc',
				}

				if (this.selectedAdvertisers.length > 0) {
					query.advs = this.selectedAdvertisers.reduce(
						(acc, { _id }) => [...acc, _id],
						[]
					)
				}

				const visits = await this.fetch_visits(this.affiliate._id, query)
				this.visitsItems = visits.data.entries
				this.totalVisits = visits.data.total
			} catch (err) {
				this.$notify({
					type: 'error',
					title: `Ocorreu um problema, ${err}`,
				})
			}
			this.dataLoading = false
		}
	},
	watch: {
		selectedAdvertisers: async function () {
			this.$root.selectedAdvertisers = this.selectedAdvertisers
		},
		startDate: function () {
			this.$root.period.startDate = this.startDate
		},
		endDate: function () {
			this.$root.period.endDate = this.endDate
		},
		pagination: {
			async handler() {
				if (!this.canRefresh) return
				await this.load_visits()
			},
			deep: true,
		},
	},
	created: function () {
		if (
			this.$root.selectedAdvertisers &&
			this.$root.selectedAdvertisers.length
		) {
			this.selectedAdvertisers = this.$root.selectedAdvertisers
		}
		this.startDate = this.$root.period.startDate
		this.endDate = this.$root.period.endDate
	}
}
</script>

<style>
/* REMOVIDO O CÓDIGO QUE ESCONDIA O HEADER */

div.visits {
	margin: 55px 10px 95px 10px;
}

/* CONTAINER PRINCIPAL COM PADDING CORRETO */
.div-container-visits-main {
	padding-left: 20px !important;
	width: 100% !important;
	max-width: 100% !important;
}

/* FILTROS */
.div-container-visits-main .div-container-selects {
	margin-top: 25px;
	padding: 12px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	/* Alinhado à esquerda */
	width: 100%;
}

.div-container-visits-main .div-container-selects .div-container-filters {
	width: 80%;
	margin-right: 20px;
}

/* Begin select data */
.div-container-visits-main .div-container-selects .div-container-filters .v-input__prepend-outer {
	margin-top: 12px;
}

.div-container-visits-main .div-container-selects .div-container-filters .v-input__slot {
	padding: 0 12px;
}

.div-container-visits-main .div-container-selects .div-container-filters .v-input__slot .v-text-field__slot {
	padding-top: 5px;
}

.div-container-visits-main .div-container-selects .div-container-filters .v-input__slot .v-label.v-label--active.theme--light {
	top: -2px;
	left: -3px !important;
}

.div-container-selects .v-menu__activator .v-input.v-text-field.v-input--is-label-active.v-input--is-dirty.v-input--is-focused.v-input--is-readonly.theme--light.primary--text .v-input__prepend-outer i {
	color: #40DA99 !important;
}

.div-container-filters .v-input__icon.v-input__icon--prepend .v-icon.material-icons.theme--light {
	color: #40DA99 !important;
}

/* End select data */

/* begin select anunciantes */

.v-menu__content.theme--light.menuable__content__active {
	border-radius: 0px 0px 13px 13px !important;
}

.v-select-list.v-card.theme--light .v-list.theme--light {
	padding: 8px;
}

.div-container-visits-main .div-container-selects .div-container-filters .v-input.v-text-field.v-select.v-input--is-label-active.v-input--is-dirty.theme--light {
	margin-top: 14px;
}

/* Chips/Tags dentro do Select Plus */
.theme--dark .div-container-visits-main .div-container-selects .div-container-filters .v-chip.v-chip--small {
	background: #2D2F32;
	border: 1px solid #c6c6c6;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-visits-main .div-container-selects .div-container-filters .v-chip.v-chip--small {
	background: #F5F5F5;
	border: none;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	color: #212121 !important;
}


/* --- BOTÃO GERAR RELATÓRIO --- */

.div-container-visits-main .div-container-filters-button button.button-generate-note {
	border-radius: 13px;
	margin-right: 10px;
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 12px;
	transform: opacity 0.2s;
}

.theme--dark .div-container-visits-main .div-container-filters-button button.button-generate-note {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-visits-main .div-container-filters-button button.button-generate-note {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.theme--light .div-container-visits-main .div-container-filters-button button.button-generate-note p {
	color: #212121 !important;
}

.div-container-visits-main .div-container-filters-button button.button-generate-note:hover {
	opacity: 0.5;
}

.div-container-visits-main .div-container-filters-button button.button-generate-note:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.div-container-visits-main .div-container-filters-button button.button-generate-note p {
	margin: 0px;
	font-size: 14px;
}

.div-container-visits-main .div-container-filters-button button.button-generate-note .v-icon.material-icons-outlined.material-icons {
	margin-bottom: 5px;
	color: #40DA99 !important;
}


/* Begin card show quatity visits */
.div-container-card-quant-visits {
	border-radius: 13px;
	margin-top: 15px;
	/* Ajuste para não colar nos filtros */
	padding: 12px;
	width: 100%;
	/* Ocupa 100% */
}

.theme--dark .div-container-card-quant-visits {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-card-quant-visits {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

div.div-container-card-quant-visits p.paragrafo-title {
	font-size: 18px;
	font-weight: 500;
	margin: 0px;
}

div.div-container-card-quant-visits p.paragrafo-subtitle {
	font-size: 11px;
	margin: 0px 0px 5px 0px;
	opacity: 0.7;
}

div.div-container-card-quant-visits p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #40DA99 !important;
}

/* Begin dataTable */
.div-container-dataTable-visits {
	margin-top: 35px;
	width: 100%;
	/* Largura total */
}

/* Modo Escuro */
.theme--dark .div-container-dataTable-visits .v-datatable.v-table {
	background: #2D2F32 !important;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px 13px 0px 0px;
}

.theme--dark .div-container-dataTable-visits .v-datatable__actions {
	background: #2D2F32 !important;
}

.theme--dark .div-container-dataTable-visits .v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: rgba(0, 0, 0, 0.5) !important;
}

/* Modo Claro */
.theme--light .div-container-dataTable-visits .v-datatable.v-table {
	background: #FFFFFF !important;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 13px 13px 0px 0px;
}

.theme--light .div-container-dataTable-visits .v-datatable__actions {
	background: #FFFFFF !important;
}

.theme--light .div-container-dataTable-visits .v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #F5F5F5 !important;
}


.div-container-dataTable-visits .v-datatable__actions .v-select__slot {
	padding: 0px 12px;
}

.div-container-dataTable-visits .v-select__slot .v-icon.material-icons.theme--light.primary--text {
	color: #40DA99 !important;
}

.div-container-dataTable-visits .v-progress-linear .primary {
	background-color: #40DA99 !important;
}


/* Media Queries */
@media (max-width: 961px) {
	.div-container-visits-main {
		margin: auto !important;
		width: 100%;
		padding-left: 0 !important;
	}
}

@media (min-width: 600px) {

	.menu-column {
		flex: 0 0 215px !important;
		max-width: 215px !important;
	}

	.div-container-visits-main {
		flex: 1 !important;
		max-width: calc(100% - 215px) !important;
		width: auto !important;
	}
}
</style>